import React from 'react';
import { FiDownload } from 'react-icons/fi';
import { Media } from '@twilio/conversations/lib/media';
import { Box, Grid, Text } from '@chakra-ui/react';

interface MediaMessageProps {
  media: Media;
}

export const formatFileSize = (bytes: number, suffixIndex = 0): string => {
  const suffixes = ['bytes', 'KB', 'MB', 'GB'];
  if (bytes < 1000) return +bytes.toFixed(2) + ' ' + suffixes[suffixIndex];
  return formatFileSize(bytes / 1024, suffixIndex + 1);
};

const FileMessage: React.FC<MediaMessageProps> = ({
  media,
}: MediaMessageProps) => {
  const handleClick = (): void => {
    media.getContentTemporaryUrl().then((url) => {
      const anchorEl = document.createElement('a');

      anchorEl.href = url;
      anchorEl.target = '_blank';
      anchorEl.rel = 'noopener';

      // setTimeout is needed in order to open files in iOS Safari.
      setTimeout(() => {
        anchorEl.click();
      });
    });
  };

  return (
    <Box
      borderRadius="4px"
      cursor="pointer"
      display="flex"
      onClick={handleClick}
      padding="0.9em 1.5em"
    >
      <Box display="flex" alignItems="center">
        <FiDownload />
      </Box>
      <Grid
        flexDirection="column"
        justifyContent="center"
        minWidth={0}
        fontSize="12px"
      >
        <Text fontWeight="700" overflow="hidden" textOverflow="ellipsis">
          {media.filename}
        </Text>
        <Text fontWeight="400">
          {formatFileSize(media.size)} - Click to open
        </Text>
      </Grid>
    </Box>
  );
};

export default FileMessage;
